import {
  COUNTRY_CODES,
  countryPreset,
  esPaisConocido,
  etiquetaPais,
  paisesOrdenados,
} from '@alexiarest/shared';

type Grupo = { label: string; options: Array<{ value: string; label: string }> };

/**
 * Opciones del selector de pais: los mercados habituales arriba y despues
 * los 240 paises por orden alfabetico. Antes solo habia siete y «Otro pais»,
 * y un cliente italiano se quedaba sin pais y en dolares (7 sep 2026).
 *
 * Sin banderas en las etiquetas: las pruebas e2e eligen por el nombre.
 */
const GRUPOS_PAIS: Grupo[] = [
  {
    label: 'Más habituales',
    options: COUNTRY_CODES.map((code) => ({ value: code, label: countryPreset(code).label })),
  },
  {
    label: 'Todos los países',
    options: paisesOrdenados().map((p) => ({ value: p.code, label: etiquetaPais(p.code) })),
  },
];

/**
 * Grupos para un selector cuyo valor actual es `actual`. Un tenant antiguo
 * con «OTHER» ve una opcion «Sin indicar» arriba para que el selector no
 * salte solo a Espana: asi se le puede pedir que elija de verdad.
 */
export function countryGroupsFor(actual: string | undefined): Grupo[] {
  if (actual === undefined || esPaisConocido(actual)) return GRUPOS_PAIS;
  return [{ label: 'Pendiente', options: [{ value: actual, label: 'Sin indicar' }] }, ...GRUPOS_PAIS];
}
